import React from "react";

export default function ShapeIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M16 4L2.14355 28H29.8564L16 4ZM16 8L5.60766 26H26.3923L16 8Z" fill="white" />
    </svg>
  );
}
